import styled, { css } from 'styled-components';
import { neutralWhite, neutralBlack, navyOverlay60, grayBorderAlpha } from '../../../themes/colors';

const CONTEST_BG: Record<string, { url: string; gradient: string }> = {
	jungle: {
		// eslint-disable-next-line max-len
		url: 'https://files.static.plecto.com/contest/backgrounds/background-jungle-without-lianas-4000x4000-5a89e3c57e.png',
		gradient: 'linear-gradient(93.37deg, #E4F2DA 0.53%, #F8FEF4 71.69%)',
	},
	mountain: {
		url: 'https://files.static.plecto.com/homepage/transparent/mountain-6424b34dc0.svg',
		gradient: 'linear-gradient(93.37deg, #D2ECFF 0.53%, #E9F4FC 71.69%)',
	},
	space: {
		url: 'https://files.static.plecto.com/homepage/transparent/space-936a76dfb4.svg',
		gradient: 'linear-gradient(90deg, #E3BDFF 0%, #F5E7FF 100%)',

	},
};

const premiumBase = css`
	border-radius: 10px;
	padding: 12px;
	box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);

	overflow: hidden;
	position: relative;

	transform: translateZ(0);
	transition: transform 180ms ease, box-shadow 180ms ease;


	&::after {
		content: '';
		position: absolute;
		inset: 0;
		pointer-events: none;
		opacity: 0;
		transition: opacity 180ms ease;
		background: radial-gradient(
      600px circle at 20% 0%,
      rgba(255, 255, 255, 0.35),
      rgba(255, 255, 255, 0) 55%
    );
	}

`;

const getBackgroundPosition = (contestType: string): string => {
	if (contestType === 'space') return 'center';
	return 'center';
};

const contestBackground = (bgUrl: string, gradient: string, contestType: string) => css`
	background: ${gradient};

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		pointer-events: none;
		z-index: -1;
		background-image: url(${bgUrl});
		background-size: cover;
		background-position: ${getBackgroundPosition(contestType)};
		background-repeat: no-repeat;
		${contestType === 'jungle' ? 'opacity: 0.14;' : ''}

	}
`;

const contestFallback = css`
	background-color: ${neutralWhite};

	background-image:
    radial-gradient(900px circle at 10% 10%, rgba(11, 119, 65, 0.06), transparent 45%),
    radial-gradient(900px circle at 90% 0%, rgba(1, 75, 172, 0.06), transparent 50%),
    radial-gradient(900px circle at 60% 90%, rgba(200, 0, 0, 0.05), transparent 55%);

	border: 1px solid ${grayBorderAlpha};
`;

const contestBackgroundCss = (contestType?: string) => {
	if (!contestType) return contestFallback;
	const config = CONTEST_BG[contestType];
	return config ? contestBackground(config.url, config.gradient, contestType) : contestFallback;
};

export const ContestPerformanceCardWrapper = styled.div<{
	$contestType?: string;
}>`
	display: flex;
	flex-direction: column;
	gap: 8px;

	${premiumBase}
	${({ $contestType }) => contestBackgroundCss($contestType)}

	padding-top: 15px;
`;

export const ContestPerformanceCardHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;

	padding-right: 160px;
`;

export const ScheduledLabelWrapper = styled.div`
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 2;
`;

export const ContestPerformanceCardTitle = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: ${neutralBlack};
	font-family: "Red Hat Display", sans-serif;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 100%;
	margin: 0;
`;

export const ContestPerformanceCardDate = styled.p`
	font-size: 14px;
	color: ${navyOverlay60};
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
`;

export const ContestPerformanceCardName = styled.h4`
	font-size: 16px;
	color: ${neutralBlack};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
`;

export const ContestPerformanceCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

export const ContestPerformanceCardContentWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const ContestPerformanceCardContentValue = styled.p`
	font-size: 16px;
	color: ${neutralBlack};
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
`;
